<template>
  <div
    class="flex flex-1 flex-row space-x-4 overflow-x-auto overflow-y-auto"
    ...attributes
  >
    {{#if (has-block "menu")}}
      <div class="flex flex-col">
        <div class="overflow-y-auto w-56">
          <ul class="menu w-full">
            {{yield to="menu"}}
          </ul>
        </div>
      </div>
    {{/if}}

    <div class="flex flex-1 flex-col overflow-x-auto overflow-y-auto">
      {{#if (has-block "tools")}}
        <div
          class="flex items-center space-x-1 p-1 border-b border-base-300 mb-3"
        >
          {{yield to="tools"}}
        </div>
      {{/if}}

      {{#if (has-block "content")}}
        <div class="flex flex-1 flex-col overflow-x-auto overflow-y-auto pr-2 pl-1">
          {{yield to="content"}}
        </div>
      {{else}}
        {{yield}}
      {{/if}}
    </div>
  </div>
</template>
